module.exports = __webpack_public_path__ + "static/img/model2-4.494153f2.jpg";